const CHANGE_TIME = {
  END: 'END',
  START: 'START'
};

const DEFAULT_CUE_DURATION = 3;
const DEFAULT_ZOOM = 0.5;
const BASE_PIXEL = 100;
const SECTION_WIDTH = 60;
const MIN_CUE_DURATION = 0.7;
const MAX_CUE_CHAR_AMOUNT = 256;

const ERROR_SUBTITLE_MIME = 'Incorrect MIME type';
const ERROR_NO_CUES = 'ERROR_NO_CUES';

const SUBTITLE_STATUS = {
  ACTIVE: 'ACTIVE',
  ERROR: 'FAILED',
  INACTIVE: 'INACTIVE',
  PROCESSING: 'PROCESSING'
};

export const SUBTITLE_TYPE = {
  UPLOAD: 'UPLOAD',
  TRANSCRIPTION: 'TRANSCRIPTION',
  TRANSLATION: 'TRANSLATION'
};

const ALLOWED_EXTENSIONS = ['vtt', 'srt'];

export const PADDING_TIME_MOVE_SECONDS = 1;
// eslint-disable-next-line @typescript-eslint/no-magic-numbers
export const POOLING_INTERVAL = 45 * 1000;
export const CHECKLIST_SELECTED_LIMIT = 3;

export {
  CHANGE_TIME,
  SECTION_WIDTH,
  DEFAULT_CUE_DURATION,
  DEFAULT_ZOOM,
  BASE_PIXEL,
  MIN_CUE_DURATION,
  MAX_CUE_CHAR_AMOUNT,
  SUBTITLE_STATUS,
  ALLOWED_EXTENSIONS,
  ERROR_SUBTITLE_MIME,
  ERROR_NO_CUES
};
